// extracted by mini-css-extract-plugin
export default {"wrapper":"SkillLabel-module__wrapper___AxvLM","moreButton":"SkillLabel-module__moreButton___I8WFd","divider":"SkillLabel-module__divider___jEwI3"};